export const SubtractIcon = () => {
	return (
		<svg width="17" height="3" viewBox="0 0 17 3" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M1.25 1.25H15.25" stroke="#A63494" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
		</svg>
	);
};
